import React, { useContext, useState } from 'react';
import Cross from '../../../../../Assets/Modals/closeIcon.svg';
import ImageAdd from '../../../../../Assets/Add image.svg';
import { useDispatch } from 'react-redux';
import { clearImages, closeModal, setVideo } from '../../../../../Features/lensSlice';
import { v4 as uuidv4 } from 'uuid';
import { VideoContext } from '../../../../../Context/VideoContext';

function Input() {
    const dispatch = useDispatch();

    const [error, setError] = useState('');

    const { loading, setVideoFile } = useContext(VideoContext);

    const handleCloseModal = () => {
        dispatch(closeModal());
        dispatch(clearImages());
    }

    const handleVideoSelection = (e) => {
        const files = Array.from(e.target.files);
        processFiles(files);
    };

    const processFiles = async (files) => {
        const file = files[0];

        const videoUrl = URL.createObjectURL(file);
        const videoElement = document.createElement('video');
        videoElement.src = videoUrl;
        videoElement.onloadedmetadata = () => {
            if (videoElement.duration > 60) {
                setError('Video length should be max 60 seconds');
            }
            else {
                setError('');
                setVideoFile(file);
                const selectedVideo = {
                    id: uuidv4(),
                    url: videoUrl,
                };
                dispatch(setVideo(selectedVideo));
            }
        };
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const files = Array.from(e.dataTransfer.files);
        processFiles(files);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    return (
        <div className={`w-2/5 relative flex flex-col h-full ${loading && 'items-center'} p-4`}>
            <div className="flex items-center justify-between">
                <h1 className='font-semibold text-2xl text-[#121212]'>Video Post</h1>

                <button onClick={handleCloseModal} className="size-11 flex items-center justify-center">
                    <img src={Cross} alt="" />
                </button>
            </div>

            <div 
                className="flex gap-6 mt-48" 
                onDrop={handleDrop} 
                onDragOver={handleDragOver} 
                onDragLeave={handleDragLeave} 
            >
                <label htmlFor='image-input' className="m-0 cursor-pointer flex flex-col items-center justify-center gap-[10px] w-full h-[140px] bg-[#E5E5E5] px-5 py-[10px] border-2 border-dashed border-[#D1D5DB] rounded-lg">
                    <div className="size-12 flex justify-center items-center">
                        <img src={ImageAdd} alt="" />
                    </div>

                    {
                        error.length ? 
                        <p className='w-4/5 text-center font-urbanist-regular font-medium text-sm text-[#ef4444e9]'>*{error}</p> : 
                        <p className='w-[35%] text-center font-urbanist-regular font-medium text-sm text-[#4B5563]'>
                            <span className='text-[#4F46E5]'>Click to Upload</span> or Drag or drop
                        </p>
                    }
                </label>

                <input 
                    className='hidden' 
                    id='image-input' 
                    type="file" 
                    accept="video/*" 
                    onChange={handleVideoSelection}
                />
            </div>
        </div>
    );
}

export default Input;
